import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Modal, Form } from 'react-bootstrap';
import { Button, ButtonWithLoading } from '@spark/ui-components/components/Button';
import { notification } from '@spark/ui-components/utils/notification';
import { addAnexoDepot } from '@spark/services/depots';

const AnexarReciboModal = ({
  show,
  onClose,
  depotId,
  onUploaded,
  enableTagSelect = false,
  defaultTag = '',
  lockTag = false,
}) => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [tagAnexo, setTagAnexo] = useState(defaultTag);

  const hasId = useMemo(() => Boolean(depotId), [depotId]);

  useEffect(() => {
    if (!show) {
      setFile(null);
      setUploading(false);
    }
    setTagAnexo(defaultTag);
  }, [show, defaultTag]);

  const handleClose = useCallback(() => {
    if (uploading) return;
    onClose?.();
  }, [onClose, uploading]);

  const handleSubmit = useCallback(async () => {
    if (!hasId) {
      notification.error('Nenhum ID selecionado para anexar o recibo.');
      return;
    }

    if (!file) {
      notification.error('Selecione um arquivo para enviar.');
      return;
    }

    if ((enableTagSelect || lockTag) && !tagAnexo) {
      notification.error('Selecione a tag do anexo.');
      return;
    }

    try {
      setUploading(true);
      const formData = new FormData();
      formData.append('arquivo', file);
      formData.append('mensagemId', '');
      formData.append('usuariosNotificar', '');
      if (tagAnexo) {
        formData.append('tagAnexo', tagAnexo);
      }

      await addAnexoDepot(depotId, formData, tagAnexo);
      notification.success('Recibo anexado com sucesso!');
      onUploaded?.();
      handleClose();
    } catch (error) {
      console.error('Erro ao anexar recibo:', error);
      notification.error('Nao foi possivel anexar o recibo.');
    } finally {
      setUploading(false);
    }
  }, [hasId, file, depotId, onUploaded, handleClose, enableTagSelect, tagAnexo]);

  return (
    <Modal show={show} onHide={handleClose} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Anexar recibo</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="reciboArquivo" className="mb-3">
            <Form.Label>Arquivo*</Form.Label>
            <Form.Control
              type="file"
              onChange={(event) => setFile(event.target.files?.[0] || null)}
              disabled={uploading}
            />
          </Form.Group>
          {enableTagSelect && !lockTag && (
            <Form.Group controlId="reciboTag" className="mb-3">
              <Form.Label>Tag do anexo*</Form.Label>
              <Form.Select
                value={tagAnexo}
                onChange={(event) => setTagAnexo(event.target.value)}
                disabled={uploading}
              >
                <option value="">Selecione</option>
                <option value="Coleta">Coleta</option>
                <option value="Devolucao">Devolucao</option>
                <option value="Depot">Depot</option>
              </Form.Select>
            </Form.Group>
          )}
          {lockTag && (
            <Form.Group controlId="reciboTagFixed" className="mb-3">
              <Form.Label>Tag do anexo</Form.Label>
              <Form.Select value={tagAnexo} disabled>
                <option value="">Selecione</option>
                <option value="Coleta">Coleta</option>
                <option value="Devolucao">Devolucao</option>
                <option value="Depot">Depot</option>
              </Form.Select>
            </Form.Group>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={uploading}>
          Cancelar
        </Button>
        <ButtonWithLoading
          variant="primary"
          onClick={handleSubmit}
          loading={uploading ? 'true' : undefined}
        >
          Enviar
        </ButtonWithLoading>
      </Modal.Footer>
    </Modal>
  );
};

export default AnexarReciboModal;
